import {Model, ModelMixin} from '../common/model.class';
import ProjectionInformation = Model.ProjectionInformation;
import moment = require('moment');
import Moment = moment.Moment;

/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
export class BirthInfo extends ModelMixin() implements Model<BirthInfo> {

    TYPE = BirthInfo;
    static projectionInformation = new ProjectionInformation('birth');

    public date?: Moment;
    public city?: string;
    public stateOrProvince?: string;
    public country?: string;

    constructor(jsonData: any = {}) {
        super();
        if (jsonData.date) jsonData.date = moment(jsonData.date);
        Object.assign(this, jsonData);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/profile/birth-info.model.ts